/**
 * @generated SignedSource<<20315c6e1e31d67303fb08f0a739423e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useWorkspaceTodoEditRemoveFileMutation$variables = {
  fileIds: ReadonlyArray<string>;
  todoWorkspaceId: string;
};
export type useWorkspaceTodoEditRemoveFileMutation$data = {
  readonly todoWorkspace: {
    readonly removeFiles: {
      readonly descriptionFiles: ReadonlyArray<{
        readonly id: string;
      }>;
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"WorkspaceTodoEditMainEditedInfo_Todo">;
    };
  };
};
export type useWorkspaceTodoEditRemoveFileMutation = {
  response: useWorkspaceTodoEditRemoveFileMutation$data;
  variables: useWorkspaceTodoEditRemoveFileMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fileIds"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "todoWorkspaceId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "todoWorkspaceId"
  }
],
v3 = [
  {
    "kind": "Variable",
    "name": "fileIds",
    "variableName": "fileIds"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "File",
  "kind": "LinkedField",
  "name": "descriptionFiles",
  "plural": true,
  "selections": [
    (v4/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useWorkspaceTodoEditRemoveFileMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "TodoWorkspaceMutation",
        "kind": "LinkedField",
        "name": "todoWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "TodoWorkspace",
            "kind": "LinkedField",
            "name": "removeFiles",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "WorkspaceTodoEditMainEditedInfo_Todo"
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useWorkspaceTodoEditRemoveFileMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "TodoWorkspaceMutation",
        "kind": "LinkedField",
        "name": "todoWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "TodoWorkspace",
            "kind": "LinkedField",
            "name": "removeFiles",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "updatedBy",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UnzonedDate",
                "kind": "LinkedField",
                "name": "updatedAtDate",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isoString",
                        "storageKey": null
                      }
                    ],
                    "type": "Date",
                    "abstractKey": "__isDate"
                  }
                ],
                "storageKey": null
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e97b3d166d0f66de417fd6be3b6902ae",
    "id": null,
    "metadata": {},
    "name": "useWorkspaceTodoEditRemoveFileMutation",
    "operationKind": "mutation",
    "text": "mutation useWorkspaceTodoEditRemoveFileMutation(\n  $todoWorkspaceId: ID!\n  $fileIds: [ID!]!\n) {\n  todoWorkspace(id: $todoWorkspaceId) {\n    removeFiles(fileIds: $fileIds) {\n      id\n      ...WorkspaceTodoEditMainEditedInfo_Todo\n      descriptionFiles {\n        id\n      }\n    }\n  }\n}\n\nfragment FormattedDate on Date {\n  __isDate: __typename\n  ...useFormattedDate\n}\n\nfragment WorkspaceTodoEditMainEditedInfo_Todo on TodoWorkspace {\n  updatedBy {\n    id\n    name\n  }\n  updatedAtDate {\n    ...FormattedDate\n  }\n}\n\nfragment useFormattedDate on Date {\n  __isDate: __typename\n  isoString\n}\n"
  }
};
})();

(node as any).hash = "1a232c875cd8c20858f50b032a72bbcc";

export default node;
